Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-wishlist'),
        wrapper;

    var model = null;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse("wishlist", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);
    };

    $wrapper.on('click', '.js-remove', function (e) {
        var $this = $(this),
            $item = $this.closest('.wishlist-item');

        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Remove(id));
    });

    $wrapper.on('click', '.js-remove-all', function (e) {
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.Clear());
    });

    $wrapper.on('click', '.js-add-to-cart', function (e) {
        var $this = $(this),
            $item = $this.closest('.wishlist-item');

        var id = $item.data('identifier'),
            productId = $item.data('productid'),
            skuId = $item.data('variantid'),
            path = $item.data('path'),
            qty = 1;

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.MoveToCart(id, productId, skuId, path, qty));
    });
    
	$wrapper.on('click', '.js-add-to-wishlist', function (e) {
		var $this = $(this),
			$item = $this.closest('.wishlist-item');

	    var id = $item.data('identifier'),
	        skuId = $item.data('variantid'),
	        path = $item.data('path'),
	        qty = 1;

		if (LhApp.Context.MultipleWishlistsEnabled && $('.js-wishlist-lists', $item).length > 0) {
			var check = $('.x-wishlist-list', $item).length < 1;
			LhApp.Function.hideAllProductWishlists();
			if (check) {
				var product = { id: id, skuId: skuId, path: path, qty: qty };
				LhApp.Function.showProductWishlists($item, product);
			}
		}
	});

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    var currentUrl = window.location.href;
    var _isWishlistPage = currentUrl.toLowerCase().indexOf("/wishlist/") !== -1;

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel(_isWishlistPage));

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, wrapper, function (envelope) {
        if (envelope.message.data.success === true) {
            model.HasValidationError = true;
            model.WarningMessage = envelope.message.data.data.Messages[0];
            wrapper.update();
            wrapper.open();
        }
        wrapper.loading(false);
    });

});
